import React, { useState } from 'react';
import { Spin, Tabs } from 'antd';
import CabinetTable from './cabinetTable';
import ApprovedCabinetOverviewTable from './approvedCabinetOverviewTable';


const ApprovedCabinet = () => {
    const [loading] = useState(false);

    return (
        <Spin spinning={loading}>
            <div className='tab-container'>
                <Tabs
                    defaultActiveKey="1"
                    animated={{inkBar: true, tabPane: true}}
                    items={[
                        {
                            key: '1',
                            label: 'Active',
                            children: <CabinetTable type='active' />,
                        },
                        {
                            key: '2',
                            label: 'Inactive',
                            children: <CabinetTable type='inactive' />,
                        },
                        {
                            key: '3',
                            label: 'Overview',
                            children: <ApprovedCabinetOverviewTable type='active' />,
                        },
                    ]}
                />
            </div>
        </Spin>
    );
};

export default ApprovedCabinet;